import api from '../utils/api';
import { cachedGet, invalidateCache, buildCacheKey } from '../utils/apiCache';

const rolesApi = {
  getAll: async (params = {}) => {
    try {
      const res = await api.get('/v1/admin/role', { params: { limit: 20, ...params } });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // Bản có cache (TTL 5 phút) cho dropdown/form tra cứu; trang list dùng getAll.
  getAllCached: async (params = {}) => {
    const queryParams = { limit: 20, ...params };
    return cachedGet(buildCacheKey('roles', queryParams), async () => {
      const res = await api.get('/v1/admin/role', { params: queryParams });
      return res.data;
    });
  },

  createRole: async (data) => {
    try {
      const res = await api.post('/v1/admin/role', data);
      invalidateCache('roles:');
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  syncRoleMenus: async (id, data) => {
    try {
      const res = await api.post(`/v1/admin/roles/${id}/menus/sync`, data);
      invalidateCache(`roleMenus:${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getRoleById: async (id) => {
    try {
      const res = await api.get(`/v1/admin/role/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getRoleMenus: async (id) => {
    try {
      const res = await api.get(`/v1/admin/roles/${id}/menus/tree`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  // Bản có cache cho AppRoutes/AppSidebar (dựng menu theo quyền).
  getRoleMenusCached: async (id) => {
    return cachedGet(`roleMenus:${id}`, async () => {
      const res = await api.get(`/v1/admin/roles/${id}/menus/tree`);
      return res.data;
    });
  },
  updateRole: async (id, data) => {
    try {
      const res = await api.patch(`/v1/admin/role/${id}`, data);
      invalidateCache('roles:');
      invalidateCache(`roleMenus:${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  deleteRole: async (id) => {
    try {
      const res = await api.delete(`/v1/admin/role/${id}`);
      invalidateCache('roles:');
      invalidateCache(`roleMenus:${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};

export default rolesApi;
